import {HashLoader} from 'react-spinners';

const Loading = () =>{
    
    return (
        <div className='m-auto'>
            <div className='content-center grid-animation'>
                <HashLoader 
                color = "#000000"
                cssOverride={{margin: '0 auto'}}
                size={50}
                speedMultiplier={0.8}
                margin={5}
                />
                <div className='loading_text'>
                    <span> 처리 중 입니다. </span>
                </div>
            </div>
        </div>
    )
}

export default Loading;